import { render, staticRenderFns } from "./OverviewKeyNumbers.vue?vue&type=template&id=5845c89f&scoped=true&"
import script from "./OverviewKeyNumbers.vue?vue&type=script&lang=js&"
export * from "./OverviewKeyNumbers.vue?vue&type=script&lang=js&"
import style0 from "./OverviewKeyNumbers.vue?vue&type=style&index=0&id=5845c89f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5845c89f",
  null
  
)

export default component.exports